// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__vGlo8","lds-ellipsis":"lds-ellipsis__1SK6U","lds-ellipsis2":"lds-ellipsis2__1cPHj","lds-ellipsis3":"lds-ellipsis3__21OrZ"};


//////////////////
// WEBPACK FOOTER
// ./components/ChatBot/styles/dots.scss
// module id = rpso
// module chunks = 0